var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
export var disabled = {
    backgroundColor: '#eaeaea',
    color: '#a6a6a6',
    cursor: 'not-allowed',
};
export var focus = {
    boxShadow: "0 0 5px ".concat('#1588af'),
    border: "".concat(1, "px solid ").concat('#1588af'),
};
export var input = __assign(__assign({}, reset), { backgroundColor: '#ffffff', border: '1px solid #cccccc', borderRadius: 2, boxSizing: 'border-box', display: 'block', fontSize: 14, outline: 'none', padding: "".concat(4 + 1, "px ").concat(8, "px ").concat(8 - 1, "px ").concat(8, "px"), position: 'relative', transition: 'box-shadow 0.3s ease-in-out', width: '100%', height: 32, '::placeholder': {
        color: '#a6a6a6',
    }, disabled: disabled, '[disabled]': disabled, ':focus': focus });
export var numberStepper = __assign(__assign({}, input), { alignItems: 'center', display: 'flex', padding: 0, input: {
        padding: "".concat(4, "px ").concat(12, "px"),
    } });
export var actionButton = {
    borderLeft: "1px solid ".concat('#cccccc', " !important"),
    borderRadius: '0 2px 2px 0',
    color: "".concat('#222222', " !important"),
    margin: '-1px -1px -1px 0 !important',
    ':after': {
        borderRadius: '0 2px 2px 0 !important',
    },
    ':focus': {
        border: "1px solid ".concat('#1588af', " !important"),
    },
    ':disabled': {
        background: 'transparent',
        color: "".concat('#cccccc', " !important"),
        border: "1px solid ".concat('#cccccc', " !important"),
    },
};
export var actionButtonLeft = {
    borderRight: "1px solid ".concat('#cccccc', " !important"),
    borderRadius: '2px 0 0 2px',
    color: "".concat('#222222', " !important"),
    left: -1,
    margin: '-1px 0 -1px -1px !important',
    order: -1,
    ':after': {
        borderRadius: '2px 0 0 2px !important',
    },
    ':focus': {
        border: "1px solid ".concat('#1588af', " !important"),
    },
    ':disabled': {
        background: 'transparent',
        color: "".concat('#cccccc', " !important"),
        border: "1px solid ".concat('#cccccc', " !important"),
    },
};
